import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { addFile } from "./defineSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";


export default function FileUpload() {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess == 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const inputRef = useRef(null);
	const dispatch = useDispatch();

	function handleInputClick() {
		inputRef.current.click();
	}

	function uploadFile(event) {
		const file = event.target.files[0];
		const obj = event.target.files[0];
		console.log(file);
		dispatch(addFile(obj));
	}
	return (
		<Box>
			 <Typography className="compHeading"
                  sx={{fontWeight: "bold", color: "blue.main", width: "100%" }}
               >
                   <AttachmentIcon sx={{ color: "blue.main", transform: "translate(0px, 6px)", mr: 1,}} />
                  Attach File
               </Typography>
			<input hidden type="file" ref={inputRef} onChange={uploadFile} />

			<Button sx={{
					bgcolor: "blue.main",
					color: "white.main",
					fontWeight: "700",
					ml: "calc(100% - 140px);",
					"&:hover": {
						bgcolor: "skyBlue.main",
						color: "black.main",
					},
				}}
				disabled = {!isRestrictedAccess}
				startIcon={<AttachmentIcon />}

				onClick={handleInputClick}
			>
				Attach File
			</Button>
		</Box>
	);
}
